import React from "react";
import { Stack, Typography, Avatar, Box, IconButton } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import { alpha, useTheme } from "@mui/material/styles";
import { Images } from "./../../assets/common";
import LockIcon from "@mui/icons-material/Lock";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { HMS, fullName, truncate } from "./../../constants/function";
import OutsideClickHandler from "react-outside-click-handler";
import "./index.scss";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import PlayIcon from "../icons/PlayIcon";
import ExplicitBadge from "../ExplicitBadge";
import AIBadge from "../AIBadge";

export default function ArtistProfileRow({
  lastIndex,
  value,
  data,
  play,
  actions,
  toggleMenu,
  isPlaylistNft,
  music,
  studio,
  reference,
}) {
  const theme = useTheme();
  const [isMenu, setMenu] = React.useState(false);
  const { t } = useTranslation("common");
  const history = useHistory();
  const isCardView = useMediaQuery("(max-width:1130px)");
  const primaryLabel = value === 2 || value === 3 ? t("trending.tabs.th8") : t("trending.tabs.th1");
  const tipperLabel = t("trending.tabs.th2");
  const streamsLabel = t("trending.tabs.th3");
  const studioLabel = t("trending.tabs.th4");
  const timeLabel = t("trending.tabs.th5");
  const moreLabel = t("trending.tabs.th6");
  return (
    <tr
      className={`artist-profile-row${isCardView ? " card-layout" : ""}`}
      style={{ position: "relative" }}
      ref={reference || null}
    >
      <td
        data-label={isCardView ? primaryLabel : undefined}
        onClick={(e) => {
          if (!studio && !e.target.closest(".prevent-row-click")) {
            play(e);
          } else if (studio && !e.target.closest(".prevent-row-click")) {
            history.push(`/app/Music/${data._id}`);
          }
        }}
        style={{ cursor: "pointer", paddingLeft: "20px" }}
      >
        <Stack direction="row" spacing={2}>
          <Stack className={"__music_thumb" + (!studio ? " _cp" : "")}>
            <Avatar
              src={
                value === 2 || value === 3
                  ? (data?.GIF?.filePath || data?.thumbnailImg?.filePath || Images.default_playlist)
                  : (data?.thumbnailImg?.filePath ?? Images.dummy1)
              }
              imgProps={{
                onError: (e) => {
                  if (value === 2 || value === 3) {
                    // For playlists, use default playlist icon
                    if (e.target.src !== Images.default_playlist) {
                      e.target.src = Images.default_playlist;
                    }
                  } else {
                    // For music, use music fallback
                    if (e.target.src !== Images.dummy1) {
                      e.target.src = Images.dummy1;
                    }
                  }
                }
              }}
            />
            {!studio ? (
              <PlayIcon
                onClick={(e) => {
                  e.stopPropagation();
                  play(e);
                }}
                className="__play_hover"
                sx={{
                  fontSize: 28,
                  position: "relative",
                  top: value !== 3 ? -20 : 0,
                }}
              />
            ) : !!Images.playlist_icon ? (
              <img
                onClick={(e) => {
                  e.stopPropagation();
                  history.push(`/app/Music/${data._id}`);
                }}
                className="__play_hover"
                src={Images.playlist_icon}
                style={{
                  top: value !== 3 ? "-20px" : "0px",
                }}
                alt="playlist"
              />
            ) : (
              <PlayIcon
                onClick={(e) => {
                  e.stopPropagation();
                  history.push(`/app/Music/${data._id}`);
                }}
                className="__play_hover"
                sx={{
                  fontSize: 28,
                  position: "relative",
                  top: value !== 3 ? -20 : 0,
                }}
              />
            )}
          </Stack>
          <Stack direction="column" alignItems="start">
            <Stack direction="row" spacing={1} alignItems="center">
              <Typography
                variant="body1"
                className="fs-16 _cp"
                sx={{ textAlign: "left" }}
                title={data["title"]}
                onClick={!studio ? (e) => {
                  e.stopPropagation();
                  play(e);
                } : (e) => {
                  e.stopPropagation();
                  history.push(`/app/Music/${data._id}`);
                }}
              >
                {truncate(data["title"], 27)}
              </Typography>
              <AIBadge show={data["isAIGenerated"]} size="small" />
              <ExplicitBadge show={data["isExplicit"]} size="small" />
              {data["private"] ? (
                <LockIcon
                  sx={{
                    width: "11px",
                    height: "11px",
                    padding: "2px",
                    color: "#989898",
                    backgroundColor: "#4E4E4E",
                  }}
                  className="__small_icon _lock_hover"
                />
              ) : null}
            </Stack>
            {value !== 3 ? (
              <Stack
                direction="row"
                sx={{
                  overflowX: "scroll",
                  gap: "6px",
                  width: isCardView ? "100%" : "245px",
                }}
                className="scroll_display_musicCard"
              >
                {data.artistData ? (
                  data.artistData.length > 1 ? (
                    data.artistData.map((a, index) => (
                      <Typography
                        onClick={(e) => {
                          e.stopPropagation();
                          history.push(`/app/ArtistProfile/${a.uId}`);
                        }}
                        key={index}
                        variant="body2"
                        className="fs-14 fade-text _cp prevent-row-click"
                        style={{ whiteSpace: "nowrap" }}
                      >
                        {value === 3
                          ? data?.artistDetails?.firstName ?? ""
                          : a?.displayArtistName ?? fullName(a)}
                        {index == data.artistData.length - 1 ? "" : ","}
                      </Typography>
                    ))
                  ) : (
                    data.artistData.map((a, index) => (
                      <Typography
                        onClick={(e) => {
                          e.stopPropagation();
                          history.push(`/app/ArtistProfile/${a.uId}`);
                        }}
                        key={index}
                        variant="body2"
                        className="fs-14 fade-text _cp prevent-row-click"
                        style={{ whiteSpace: "nowrap" }}
                      >
                        {value === 3
                          ? data?.artistDetails?.firstName ?? ""
                          : a?.displayArtistName ?? fullName(a)}
                      </Typography>
                    ))
                  )
                ) : (
                  <Typography variant="body2" className="fs-14 fade-text">
                    {value === 3
                      ? data?.artistDetails?.firstName ?? ""
                      : value === 1
                        ? fullName(data["createdByDetails"])
                        : data?.artist ?? ""}
                  </Typography>
                )}
              </Stack>
            ) : null}
          </Stack>
        </Stack>
      </td>

      {value == 4 ? null : (
        <td data-label={isCardView ? tipperLabel : undefined} style={{ paddingLeft: "16px" }}>
          <Stack
            direction="row"
            spacing={2}
            alignItems="center"
            justifyContent="start"
          >
            {data?.topTipper?.topTipperProfile?.filePath ? (
              <Avatar src={data?.topTipper?.topTipperProfile?.filePath} />
            ) : null}
            <Typography
              variant="body2"
              className="fs-14"
              sx={{ textAlign: "start" }}
            >
              {data?.topTipper?.topTipperName ?? ""}
            </Typography>
          </Stack>
        </td>
      )}

      <td data-label={isCardView ? streamsLabel : undefined} style={{ paddingLeft: "16px" }}>
        <Typography variant="body2" className="fs-14 fade-text">
          {Math.round(data?.listens ?? 0)}
        </Typography>
      </td>

      {value == 4 || value === 2 ? null : (
        <td data-label={isCardView ? studioLabel : undefined} style={{ paddingLeft: "16px" }}>
          <Typography variant="body2" className="fs-14 fade-text">
            {data?.topStudio?.playlistName ?? ""}
          </Typography>
        </td>
      )}
      <td data-label={isCardView ? timeLabel : undefined} className="text-white fs-14" style={{ paddingLeft: "16px" }}>
        {data["duration"]
          ? HMS(data["duration"])
          : data["totalDuration"]
            ? HMS(data["totalDuration"])
            : ""}
      </td>
      <td data-label={isCardView ? moreLabel : undefined} className="text-right pr18">
        <IconButton
          onClick={(e) => {
            e.stopPropagation();
            setMenu(!isMenu);
          }}
        >
          <MoreVertIcon
            className="_cp"
            sx={{
              color: theme.palette.primary.main,
              backgroundColor: alpha(
                theme.palette.primary.main,
                theme.palette.mode === "light" ? 0.12 : 0.3
              ),
              borderRadius: "50%",
              padding: "2px",
            }}
          />
        </IconButton>
      </td>

      {isMenu ? (
        <OutsideClickHandler onOutsideClick={() => setMenu(false)}>
          <Box
            className="__music_card_menu"
            sx={{ position: "absolute" }}
            style={{ top: lastIndex ? "-40px" : "40px", right: 0 }}
          >
            {actions.map(({ action, key }, index) =>
              action ? (
                <Typography
                  className="__music_card_menu_item"
                  key={index}
                  onClick={(e) => {
                    e.stopPropagation();
                    setMenu(false);
                    toggleMenu(key, data["_id"] ? data["_id"] : "");
                  }}
                >
                  {action}
                </Typography>
              ) : null
            )}
          </Box>
        </OutsideClickHandler>
      ) : null}
    </tr>
  );
}
